// models
import type { BaseSearchRequest } from 'modules';

/**
 * Nation 관련 Query Keys
 *
 * @description
 * 국가 관련 query-key들을 관리합니다.
 */
export const nationKeys = {
  /** ALL */
  NATION_ALL: ['nation'],

  /** 국가 목록 조회 */
  GET_NATION_LIST: (params: BaseSearchRequest) => [
    'nation',
    'getNationList',
    JSON.stringify(params)
  ]
};
